import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnPW: CultureInfo = {
  name: 'en-PW',
  displayName: 'English (Palau)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-PW',
  parent: CultureInfoEn
};
